var map = {
	"./business-services.json": [
		"9449",
		"chunk-2d0e53d6"
	],
	"./cloud-services.json": [
		"e78a",
		"chunk-2d226011"
	],
	"./it-managed-services.json": [
		"a874",
		"chunk-2d20920a"
	],
	"./professional-services.json": [
		"cb98",
		"chunk-2d2218b4"
	],
	"./web-services.json": [
		"9652",
		"chunk-2d0e5b70"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "6365";
module.exports = webpackAsyncContext;